import { render, staticRenderFns } from "./GroupCertificateCard.vue?vue&type=template&id=7fe35a40&scoped=true&"
import script from "./GroupCertificateCard.vue?vue&type=script&lang=js&"
export * from "./GroupCertificateCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe35a40",
  null
  
)

export default component.exports